import { create } from "zustand";

export interface BibtexImportProgress {
  resolved: number;
  total: number;
  currentTitle: string;
  statusMessage: string;
}

interface BibtexImportState {
  isImporting: boolean;
  isCompleted: boolean;
  error: string | null;
  jobId: string | null;
  progress: BibtexImportProgress;

  startImport: (jobId: string, total: number) => void;
  updateProgress: (update: Partial<BibtexImportProgress>) => void;
  completeImport: (message: string) => void;
  failImport: (error: string) => void;
  resetImport: () => void;
}

const initialProgress: BibtexImportProgress = {
  resolved: 0,
  total: 0,
  currentTitle: "",
  statusMessage: "",
};

export const useBibtexImportStore = create<BibtexImportState>((set, get) => ({
  isImporting: false,
  isCompleted: false,
  error: null,
  jobId: null,
  progress: { ...initialProgress },

  startImport: (jobId, total) =>
    set({
      isImporting: true,
      isCompleted: false,
      error: null,
      jobId,
      progress: { ...initialProgress, total, statusMessage: "Starting import..." },
    }),

  updateProgress: (update) =>
    set((state) => ({
      progress: { ...state.progress, ...update },
    })),

  completeImport: (message) =>
    set({
      isImporting: false,
      isCompleted: true,
      progress: { ...get().progress, statusMessage: message },
    }),

  failImport: (error) =>
    set({
      isImporting: false,
      error,
    }),

  resetImport: () =>
    set({
      isImporting: false,
      isCompleted: false,
      error: null,
      jobId: null,
      progress: { ...initialProgress },
    }),
}));
